import type { AdminRolesListParams } from '../types/role.types';

export const roleKeys = {
  all: ['roles'] as const,
  lists: () => [...roleKeys.all, 'list'] as const,
  list: (params: AdminRolesListParams) => [...roleKeys.lists(), params] as const,
};
